import React from 'react'
import { $t } from '~/i18n.js'

import { Tooltip } from 'antd'
import { DataCard } from '~/components/dataCards/dataCard.jsx'
import { clubHasFlight } from '~/featureMatrix.jsx'

export const CardStart = ({ club, profile, gegevens, saveData, type, message }) => {
  // automatically start
  const saveForm = async () => saveData()

  return (
    <DataCard title={$t('Start')} onSave={saveForm} type={type} buttonTitle={$t('Start')}>

      <p className='bold large spacer'>{$t('Is je profiel nog up to date?')}</p>

      <p className='spacer'>{$t('Als zweefvliegclub willen we dat de administratie ten behoeve van vliegactiviteiten sluitend en ondersteunend is voor een soepel en veilig vliegbedrijf.')}</p>

      <p>{$t('Zou jij het volgende kunnen kunnen verifiëren?')}</p>

      <ul>
        <li>{profile.avatar ? $t('Is je profielfoto recent en helder?') : $t('Je mist een profielfoto')}</li>
        <li>{(profile.phone ? $t('Is je telefoonnummer nog geldig?') : $t('We missen je telefoonnummer'))}</li>
        <li>{(gegevens.address1 ? $t('Is je woonadres nog geldig?') : $t('We missen je woonadres'))}</li>
        <li>{(gegevens.emergency_contact ? $t('Is je noodcontact nog geldig?') : $t('We missen je contactpersoon in geval van nood'))}</li>
      </ul>
    </DataCard>
  )
}
